module.exports = __webpack_public_path__ + "img/gmail.c0482baf.svg";